module.exports = __webpack_public_path__ + "static/navbg-01e77eb37053d53721edbcd4ba957633.svg";